import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getStripeProductPrices } from 'src/components/Education/functions'
import { IPrice, IReducer } from 'src/interface'

export const useProductPrice = (productId: string | string[]) => {
  const educationProducts = useSelector((state: IReducer) => state.stripeProductsReducer.educationProducts)
  const [prices, setPrices] = useState<IPrice[] | null>([])

  useEffect(() => {
    if (educationProducts && educationProducts.length > 0) {
      const prices = getStripeProductPrices({
        products: educationProducts,
        productIds: productId
      })
      setPrices(prices)
    }
  }, [educationProducts])

  return { prices }
}
